import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import enUs from './en-us'
import zhHk from './zh-hk'

// 注册 i18n 插件
Vue.use(VueI18n)

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: 'zh', // 默认语言（中文）
  fallbackLocale: 'zh', // 备用语言（当前语言无文案时兜底）
  messages: {
    zh,          // 简体：zh
    'en-us': enUs,        // 英文：en
    'zh-hk': zhHk
  } // 挂载语言包
})

export default i18n